export const checkBoxConfig = () => {
  return {
    width: '1.75rem',
    height: '1.75rem',
    iconSize: '1.2rem'
  }
}
